import { ErrorHandler, Injectable } from '@angular/core';
import { SnackBarService } from '@teammood/shared/ui/snack-bar';
import { LoggerService } from '../logger';
import { TrackJS } from "trackjs";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private _loggerService: LoggerService,
  ) { }

  handleError(error: any): void {

    // Log the error to the console.
    if (error){
      this._loggerService.error('Unmanaged error occurred', error);
    } else {
      this._loggerService.error('Unmanaged error occurred, undefined error, cannot say more');
    }

    // send to TrackJS
    TrackJS.track(error.originalError || error);
  }
}